module.exports = __webpack_public_path__ + "img/main_bg_old.7c5c191.webp";